export const queryKeys = {
  admin: {
    faqGroups: 'adminFaqGroups',
    faqItems: 'adminFaqItems',
    serviceMessages: 'adminServiceMessages',
    userGroups: 'adminUserGroups',
    users: 'adminUsers',
  },
  auth: 'auth',
  conversations: 'conversations',
  faqGroups: 'faqGroups',
  messageStatus: 'messageStatus',
  onboardingTips: 'onboardingTips',
  pendingConversations: 'pendingConversations',
  promptTemplates: 'promptTemplates',
  refreshToken: 'refreshToken',
  serviceMessages: 'serviceMessages',
  suggestions: 'suggestions',
  user: 'user',
  userCarousels: 'userCarousels',
}

export const ADMIN_DEFAULT_PER_PAGE = 20
export const DEFAULT_PER_PAGE = 35
export const PROMPT_TEMPLATE_PER_PAGE = 10

export const conversationsQueryKeys = {
  conversationsList: (query?: string) =>
    [queryKeys.conversations, { query: query || null }] as const,
  conversationDetails: (id: string) =>
    [queryKeys.conversations, id] as const,
}
